<div class="content short">
    <app-filter-table
        *ngIf="analiticsData.length>0"
        class="analitics-table"
        [filtersOff]='true'
        [data]="analiticsData"
        [columns]="columns">
    </app-filter-table>
    <div *ngIf="analiticsData.length==0" class="empty">
        <img src="../../.././../assets/images/AdCreator/adIcon.png" alt="">
        <h1>There are no statistics yet</h1>
    </div>
</div>